import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  dropdownButton: {
    fontWeight: 700,
    height: '3.8rem',
    padding: '0px 1rem',
    fontSize: '1.6rem',
    lineHeight: '2.6rem',
  },
  dropdownOpenedBtn: {
    border: '2px solid transparent',
  },
  dropdownOption: { padding: '1.6rem' },
  removeOption: {
    '&:hover': {
      backgroundColor: colors.red[100],
    },
    '&:active': {
      backgroundColor: colors.red[600],
      '& button': {
        color: colors.neutral.black,
      },
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
